<div class="side-navbar">
    <ul class="nav nav-pills flex-column mb-auto">
        <li class="nav-item" style="margin-top: 40px;">
            <a class="nav-link" routerLinkActive="active" aria-current="page" routerLink="/dashboard/seller/dashboard">
                <i class="fa-solid fa-house"></i>
                {{'sidebar.dashboard' | translate}}
            </a>
        </li>
        <li>
            <a class="nav-link " routerLinkActive="active" routerLink="/dashboard/seller/edit-profile"
                [queryParams]="{edit:'1'}">
                <i class="fa-solid fa-user"></i>
                <span class="label-menu">{{'sidebar.profile' | translate}}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/seller/vehicle-list">
                <i class="fa-solid fa-car"></i>
                {{'sidebar.my-vehicles' | translate}}
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/seller/add-vehicle">
                <i class="fa-solid fa-plus"></i>
                {{'sidebar.add-vehicles' | translate}}
            </a>
        </li>
        <li>
            <a class="nav-link " routerLinkActive="active" routerLink="/dashboard/seller/sales"
                [queryParams]="{edit:'1'}">
                <i class="fa-solid fa-tag"></i>
                <span class="label-menu">{{'sidebar.sales' | translate}}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/seller/transaction">
                <i class="fa-solid fa-cart-shopping"></i>
                {{'sidebar.payment' | translate}}
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/seller/statement">
                <i class="fa-solid fa-receipt"></i>
                {{'sidebar.statement' | translate}}
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/seller/user-queries">
                <i class="fa-regular fa-circle-question"></i>
                {{'sidebar.tickets' | translate}}
            </a>
        </li>
        <!-- <li>
            <a class="nav-link " routerLinkActive="active" routerLink="/dashboard/seller/login-session">
                <i class="fa-solid fa-boxes-stacked"></i>
                Session Logs
            </a>
        </li> -->
    </ul>
</div>